import { hexSha2 } from '@/utils/sha1'

function productParam(openId : any) {
    const  state = {
       'clinique' : 'clinique',
       'origins' : 'origins',
    } as Record<string, string>

    const clienId = {
        'clinique' : '96b0ad3a', // clinique生产 96b0ad3a
        'origins' : '5d16c407', // origins 生产 5d16c407
    } as Record<string, string>

    const redirectUrl = {
        'clinique' : 'https://cdp-elc-prod.elcapp.cn/api/elc-data-realtime/vip/route/webpage/4f4807d7a2ccb4f2abd89a8a0a798c4e',
        'origins' : 'https://el-tiktok-prod.elcapp.cn:12160/webpage/4f4807d7a2ccb4f2abd89a8a0a798c4e',
    } as Record<string, string>

    const params = {
        vopClientId: clienId[openId], // [clienId[openId]] clinique -> 沙箱 2a386b13  生产 96b0ad3a  origins 生产 5d16c407
        scope: 'user_base', 
        responseType: 'code',
        state: state[openId],
        vopTimestamp: Math.floor(((new Date()).getTime() / 1000)),
        redirectUrl: redirectUrl[openId],
        businessType: '1',
        businessValue: state[openId] // 倩碧=clinique，悦木之源=origins
    } as Record<string, number | string>
    
    // 过滤出非 vop 开头的参数
    const vopReqParams = Object.keys(params).filter(item => {
        return item.indexOf('vop') !== 0;
    }).reduce((v, key) => {
        v[key] = params[key];
        return v;
    }, {});
    
    // 配置用于计算验签的参数
    let signParams = JSON.parse(JSON.stringify(vopReqParams));
    signParams.vopClientId = params.vopClientId;
    signParams.vopTimestamp = params.vopTimestamp;
    // 拼接用于验签的字符串
    // 字母顺序，升序排列
    const signString = Object.keys(signParams).sort((a,b) => {return a > b ? 1 : -1}).map(item => {
        // 注意：这里直接拿参数值，不用 encodeURIComponent
        return `${item}=${signParams[item]}`;
    }).join('&').concat(`&${params.vopClientId}`);

    console.log('signString===>',signString)
    // 计算 sha1 的值（自行引入 sha1 函数）

    const vopSign = hexSha2(signString);

    // // 拼接授权链接

    let urlParams = {
        vopClientId: params.vopClientId as string,
        vopTimestamp: params.vopTimestamp as number,
        vopSign: vopSign as string,
        vopIsPureH5: 'true' as string,
        vopReq: JSON.stringify(vopReqParams) as string
    }

    const urlParamsString = Object.keys(urlParams).map((item:any) => {
        return `${item}=${encodeURIComponent(urlParams[item])}`;
    }).join('&');

    // oauthUrl 就是授权链接

    const oauthUrl = `https://mlogin.vip.com/asserts/login/oauth.html?${urlParamsString}`;
    return oauthUrl;
}

export default productParam;
